// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.notification.gcm.enums.RentalManagerNotificationStatus

export enum RentalManagerNotificationStatus {
  READ = 'READ',
  UNREAD = 'UNREAD',
}

export const RentalManagerNotificationStatus_values = [
  RentalManagerNotificationStatus.READ,
  RentalManagerNotificationStatus.UNREAD,
] as const;
